import { GeoCoord } from "lib/at-data/GeoCoord";
import { polygon } from "@turf/turf";

export const toPolygon = (coords: Array<GeoCoord>) => polygon([coords]);
